import React from "react";
import Label from "../atoms/Label";
import { markdownToJSX } from "../../util/transforms";
import ReadMore from "../molecules/ReadMore";
import { MEDIUM } from "../util/breakpoints";
import Sign from "../molecules/Sign";
import Image from "../atoms/Image";
import useMediaQuery from '../util/useMediaQuery'
import contentfulRichText from "../util/contentfulRichText"

export default ({ label, title, text, richText, image, link, sign, isLight = false, translations }) => {
    const isMediumUp = useMediaQuery({ minWidth: MEDIUM });

    return (
        <section className="u-section-spacing">
            <div className={ "o-image-bg-text" + (isLight ? " u-background" : " u-background-dark-blue") }>
                { image &&
                <div className="o-image-bg-text__media">
                    <Image className={ "o-image-bg-text__image" + (isMediumUp ? " o-image-bg-text__image--fit" : "") } image={ image }/>
                </div>
                }
                <div className={ "o-image-bg-text__wrapper " +
                    (isLight ? " o-image-bg-text__wrapper--light" : "") +
                    (isMediumUp ? " u-container" : "") }
                >
                    <div className="o-image-bg-text__content">
                        <Label isWhite={ !isLight } text={ label }/>
                        { title && <h2 className="o-image-bg-text__title">{ markdownToJSX(title) }</h2> }
                        { richText && contentfulRichText(richText) } 
                        { !richText && text && <p>{ text }</p> }
                        { sign && <Sign text={ sign.signText }/> }
                        { link && <ReadMore isWhite={ !isLight } text={ link.title } link={ link } translations={ translations }/> }
                    </div>
                </div>
            </div>
        </section>
    );
}

